import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import enJSON from './locale/en.json';
import enErrors from './locale/errors.en.json';
import inviteTeamMember from './locale/inviteTeamMember.json';
export const defaultNS = 'enJSON';

export const resources = {
  en: {
    enJSON,
    enErrors,
    inviteTeamMember,
  },
} as const;

i18next.use(initReactI18next).init({
  resources,
  defaultNS: defaultNS,
  lng: 'en',
  ns: ['enJSON', 'enErrors', 'inviteTeamMember'], // Specify the namespaces to use
});

export default i18next;
